import backBtn from "../../assets/icons/back-btn.png";
import logo from "../../assets/doctio-logo.svg";
import fraseIkon from "../../assets/icons/Paper-icon + circle.svg";
import airplane from "../../assets/icons/paperplane.png";
import sygeplejerske from "../../assets/people/TBV03890.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StatsData } from "../../types/Signup/SignUpStep";
import { Link } from "react-router-dom";
import Stats from "../Stats/Stats";

export default function SignUpStep3({
  prevStep,
  statsData,
  email,
}: {
  prevStep: Function;
  statsData: StatsData;
  email: string;
}) {
  const requestNewEmail = async () => {
    try {
      const response = await fetch(
        `https://test.doctio.dk/api/activations/email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );
      const jsonData = await response.json();
      toast.success("Vi har sendt dig en ny mail.");
      console.log(jsonData);
    } catch (error) {
      toast.error("Der skete en fejl. Prøv igen senere.");
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white mx-auto container md:w-2/3 md:mx-auto md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => prevStep()}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="text-d2xl font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
              Din profil er næsten klar!
            </h1>

            <p>
              Vi har sendt dig en bekræftelsesmail i din inbox. Klik på linket i
              mailen for at færdiggøre din profil og vælge abonnoment. Hvis du
              ikke kan se den så tjek din spam folder eller{" "}
              <a
                href="/request"
                className="underline text-doctio-green"
                onClick={() => requestNewEmail()}
              >
                anmod igen.
              </a>
            </p>

            <img
              src={airplane}
              className="mx-auto mt-32 w-5/6"
              alt="Sendt email"
            />
          </div>

          <div className="relative container md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 md:mx-auto">
              <div className="image-container relative  mb-10 md:mb-0">
                <div className="header mt-6 mb-6 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => prevStep()}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={sygeplejerske}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit picture-shadow rounded-3xl"
                  alt="Sygeplejerske"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2">Bruger af Doctio</p>
                </div>

                <div className="absolute frase-ikon-sign hidden md:block left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Tilbage"
                  />
                </div>
              </div>
              <Stats data={statsData} />
              <ToastContainer />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
